const roles = {
  superAdmin: 'superadmin',
  memberCare: 'membercare',
  peerSupport: 'peersupport',
  peerSupportLead: 'peersupportlead',
  orgAdmin: 'organizationadmin',
  orgEmployee: 'organizationemployee',
  contentCreator: 'contentcreator',
} as const;

export type TUserRole = (typeof roles)[keyof typeof roles];

export const rolesDisplayLabel: Record<TUserRole, string> = {
  membercare: 'Member Support',
  peersupport: 'Peer Support',
  peersupportlead: 'Peer Support Lead',
  superadmin: 'Super Admin',
  organizationadmin: 'Admin',
  organizationemployee: 'Employee',
  contentcreator: 'Content Creator',
};

export default roles;
